//logue simplement la version webpack et si c'est une version de prod ou non.
console.log("webpack version...",webpackVersion);
console.log("webpack PRODUCTION...",PRODUCTION);



// WEBPACK FOOTER //
// ./vendor/davidmars/classiq/Classiq/_src/cq-debug/WebpackVersion.js